import { useApi } from 'api/api-context';
import EvidenceFieldSectionsAdmin from 'components/forms/evidence-field/EvidenceFieldSectionsAdmin';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { ROLE_ADMIN_ID } from 'model/Role';
import { Navigate } from 'react-router-dom';
import { DASHBOARD_PAGE_PATH } from 'routes/paths';

/**
 * Page used to manage evidence-field sections.
 */
export default function EvidenceFieldSectionsPage() {
  const { roleId } = useApi();

  if (roleId !== ROLE_ADMIN_ID) {
    return <Navigate to={DASHBOARD_PAGE_PATH.original} replace />;
  }

  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Sekcie polí' }]}>
      <EvidenceFieldSectionsAdmin />
    </DashboardLayout>
  );
}
